import BaseApi from './BaseApi'

class HelperApi extends BaseApi {
  getLanguages () {
    // return this.get('languages')
    // Promise filter wrapper
    return new Promise((resolve, reject) => {
      this.get('languages')
        .then(languages => resolve(languages.filter(language => language.name !== `ru`)))
        .catch(error => reject(error))
    })
  }

  getCities (config) {
    let suffix = Object.keys(config)
      .map(key => `${key}=${config[key]}`)
      .join('&')

    return this.get(`cities${suffix ? '?' + suffix : ''}`)
  }

  getPaymentPlans () {
    return this.get(`payment/plans`)
  }
}

export default new HelperApi()
